import React from 'react';
import { SelectType } from '@components/forms/box-office/select-type';
import { IconDownload, IconPrint } from '@components/icons';
import { SummaryFormModalContent } from '@components/modals/summary-form-modal';
import { SummarySuccessModalContent } from '@components/modals/summary-success-modal';
import { STEP_INFO, STEP_SELECT_TYPE, STEP_SUCCESS } from '@constants/process-steps';

import { PrintModal } from '../components/print-modal';
import { SuccessMessage } from '../components/success-message';

import { BoxOfficeStepsProps } from './process-box-office.type';

/*
 * BoxOfficeSteps Component
 *
 * Pure component that renders the specific steps for the Box Office process.
 * Receives all data and handlers as props from the parent ProcessBoxOffice component.
 */

export const BoxOfficeSteps: React.FC<BoxOfficeStepsProps> = ({
  step,
  setStep,
  offer,
  event,
  quantity,
  availableAddons,
  selectedAddonIds,
  isSubmitting,
  onSubmit,
  onClose,
  filteredOffer,
  newBoxOfficeProcess,
  handleSecondarySuccessAction,
  boxOfficeData,
  email,
  pdfFile,
  isOpenPdfFileModal,
  setIsOpenPdfFileModal,
  mobileViewport,
  isWebView,
  t,
}) => {
  return (
    <>
      {step === STEP_SELECT_TYPE && <SelectType onContinue={() => setStep(STEP_INFO)} offer={offer} />}
      {step === STEP_INFO && offer && event && (
        <SummaryFormModalContent
          event={event}
          offer={filteredOffer(offer)}
          addons={availableAddons}
          quantity={quantity}
          selectedAddons={selectedAddonIds}
          onContinue={onSubmit}
          optionalFields
          handleClose={onClose}
          title={t('offers:fillInfoBoxOfficeTitle')}
          mainActionText={email ? t('offers:printAndSend') : t('offers:print')}
          mainActionIcon={IconPrint}
          isSubmitLoading={isSubmitting}
        />
      )}
      {step === STEP_SUCCESS && offer && (
        <SummarySuccessModalContent
          offer={offer}
          addons={availableAddons}
          quantity={quantity}
          onClickMainAction={newBoxOfficeProcess}
          onClickSecondaryAction={handleSecondarySuccessAction}
          onClickClose={onClose}
          title={t('offers:processBoxOfficeSuccessTitle')}
          headerDescription={<SuccessMessage bookingLegacyId={boxOfficeData?.legacyId} email={email} />}
          bookingLegacyId={boxOfficeData?.legacyId}
          mainActionText={t('offers:addGuest')}
          secondaryActionText={mobileViewport ? t('offers:downloadPdf') : t('offers:printAgain')}
          secondaryActionIcon={mobileViewport ? IconDownload : IconPrint}>
          {pdfFile && !isWebView && !mobileViewport ? (
            <PrintModal
              isOpen={isOpenPdfFileModal}
              toggleModal={setIsOpenPdfFileModal}
              isMobile={mobileViewport}
              file={pdfFile as string}
            />
          ) : undefined}
        </SummarySuccessModalContent>
      )}
    </>
  );
};
